<template>
  <div class="serviceSelection">
    <el-button
      v-if="services.length === 1"
      plain
      @click="goToService(services[0])"
    >
      Go to {{ services[0].svc_name }}
    </el-button>

    <el-dropdown
      v-else-if="services.length > 1"
      trigger="click"
      @command="goToService"
    >
      <el-button icon="el-icon-menu" />
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(service, key) in services"
          :key="key"
          :command="service"
        >
          {{ service.svc_name }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ServiceSelection',

  computed: {
    ...mapState({
      services: (state) => {
        console.log(state);
        const services = state.user.user.services.filter(
          (el) => el.svc_frontend_url && el.service_id !== process.env.VUE_APP_SERVICE,
        );

        if (state.user.user.is_staff && process.env.VUE_APP_SERVICE !== 'mam') {
          services.unshift({
            svc_name: 'MAM Dashboard',
            service_id: 'mam',
            svc_frontend_url: process.env.VUE_APP_MAM_CLIENT,
          });
        }
        return services;
      },
    }),
  },

  methods: {
    goToService(service) {
      console.log(service);
      window.location.href = service.svc_frontend_url;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-button {
  background: var(--themeCardColor);
  color: var(--themeFontColor);
  border-width: 0;
}

.el-dropdown-menu__item {
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
}
</style>
